import React, { Suspense, useContext } from "react";

import "./scss/main.scss";
import { Route, Switch, Redirect } from "react-router-dom";

import Loading from "./components/UI/Loading";
import { AuthContext } from "./components/Auth/AuthContext";
import { useLastLocation } from "react-router-last-location";
// General Page Component
const Home = React.lazy(() => import("./pages/Home"));
const Courses = React.lazy(() => import("./pages/Courses"));
const Categories = React.lazy(() => import("./pages/Categories"));
const About = React.lazy(() => import("./pages/About"));
const SingleCategory = React.lazy(() => import("./pages/SingleCategory"));
const SingleCourse = React.lazy(() => import("./pages/SingleCourse"));
const Talents = React.lazy(() => import("./pages/Talent"));
const SingleTalent = React.lazy(() => import("./pages/SingleTalent"));
const Showcase = React.lazy(() => import("./pages/Showcase"));
const SingleProject = React.lazy(() => import("./pages/ProjectDetail"));
const CartPage = React.lazy(() => import("./pages/Cart"));

// Auth Page Component
const Login = React.lazy(() => import("./pages/Login"));
const Register = React.lazy(() => import("./pages/Register"));

// Protected Page Component
const Profile = React.lazy(() => import("./pages/User/Profile"));
const HomeDashboard = React.lazy(() => import("./pages/User/HomeDashboard"));
const ChangePassword = React.lazy(() => import("./pages/User/ChangePassword"));
const MyOrder = React.lazy(() => import("./pages/User/MyOrder"));
const OrderDetail = React.lazy(() => import("./pages/User/OrderDetail"));
const MyCourses = React.lazy(() => import("./pages/User/MyCourses"));
const MyProject = React.lazy(() => import("./pages/User/MyProject"));
const LearningPage = React.lazy(() => import("./pages/User/LearningPage"));
const AddProject = React.lazy(() => import("./pages/User/AddProject"));
const EditProject = React.lazy(() => import("./pages/User/EditProject"));

function DashboardRoutes() {
  return (
    <Switch>
      <Route exact path="/dashboard" component={HomeDashboard} />
      <Route path="/dashboard/edit_profile" component={Profile} />
      <Route path="/dashboard/change_password" component={ChangePassword} />

      <Route path="/dashboard/my_courses" component={MyCourses} />
      <Route path="/dashboard/learn/:slug" component={LearningPage} />

      <Route path="/dashboard/my_orders" component={MyOrder} />
      <Route path="/dashboard/my_order/:id" component={OrderDetail} />

      <Route path="/dashboard/my_projects" component={MyProject} />
      <Route path="/dashboard/add_new_project" component={AddProject} />
      <Route path="/dashboard/edit_project/:id" component={EditProject} />
    </Switch>
  );
}

function App() {
  const [isAuth, , , , , , loading, ,] = useContext(AuthContext);
  console.log(isAuth);
  const lastLocation = useLastLocation();

  return (
    <div className="App">
      <Suspense fallback={<Loading />}>
        <Switch>
          <Route
            path="/login"
            render={() =>
              loading ? (
                <Loading />
              ) : isAuth ? (
                <Redirect to={{ pathname: lastLocation?.pathname }} />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/register"
            render={() =>
              loading ? (
                <Loading />
              ) : isAuth ? (
                <Redirect to="/dashboard" />
              ) : (
                <Register />
              )
            }
          />
          <Route exact path="/" component={Home} />
          <Route path="/about" component={About} />
          {/* Course Route */}
          <Route path="/courses" component={Courses} />
          <Route path="/course/:slug" component={SingleCourse} />
          {/* Category Route */}
          <Route exact path="/categories" component={Categories} />
          <Route path="/categories/:slug" component={SingleCategory} />
          {/* Talent Route */}
          <Route path="/talents" component={Talents} />
          <Route path="/talent/:username" component={SingleTalent} />
          {/* Project Route */}
          <Route path="/showcase" component={Showcase} />
          <Route path="/project/:id" component={SingleProject} />
          {/* Cart Route */}
          <Route path="/cart" component={CartPage} />

          {/* Dashboard Route */}
          <Route
            path="/dashboard"
            render={() =>
              loading ? (
                <Loading />
              ) : isAuth ? (
                <DashboardRoutes />
              ) : (
                <Redirect to="/login" />
              )
            }
          />
        </Switch>
      </Suspense>
    </div>
  );
}

export default App;
